import React, { Component } from "react";
import {
  dropdownCustom,
  LoadingOption,
  OptionMultiple,
} from "./SelectOption";
import { Col, Row, Select } from "antd";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import MultipleSelect from "./MultipleSelect";
import _ from "lodash";
import { Checkbox } from "../../asset";
import { GROLOG_URL } from "../../constant/apiConstant";
import axios from "axios";
// import ErrorMessage from "../message/ErrorMessage";

const optionList = {
  limitOption: 10,
  listOption: [],
  pageOption: 1,
  storeOption: [],
  storeValue: `0 of 0`,
  lastPageOption: false,
  loadingOption: true,
  filterOption: null,
  isFilter: false,
  valueMultipleSelectOption: [],
  countData: {
    count_data: 0,
  },
  storeOptionId: [],
  valueToParent: [],
  listExclude: [],
  exclude: false,
  selectAllOption: false,
  temporaryStoreOption: [],
  initOption: [],
  changingParent: false,
  changingLevel: false,
  list:[],
  initiate:[]
};

const { Option } = Select;

class MSSTemperatureCategory extends Component {
  state = {
    ...optionList,
  };

  doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    
  const api = GROLOG_URL;
    const url = api + endpoint;
    const method = "GET";
    const headers = { "Authorization": tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

componentDidMount =async()=> {
    let init = await this.doGet(
      `/temperature-category/initiate?${this.props.param}`,
      this.props.token
    );
    let res = await this.doGet(
      `/temperature-category/dropdown?page=1&limit=${init?.data?.payload?.data?.count_data}&${this.props.param}`,
      this.props.token
    );
    let option=[]
    res.data.payload.data.map((el)=>{
      option.push({
        code: el.id,
          id: el.id,
          name: el.value,
      })
    })
    this.setState({
      list:option,
      initiate:init?.data?.payload?.data
    })
    // apabila props level 1 langsung melakukan fetching
    if (this.props.level === 1 || this.props.currentValue) {
      this.setState(
        {
          loadingOption: true,
          valueMultipleSelectOption: [],
          listExclude: [],
        },
        () =>
          this.getData(
            this.state.pageOption,
            this.state.limitOption,
            this.state.filterOption,
            this.props?.level,
            this.props?.parentId
          )
      );
      // jika props level bukan 1, tapi ada props parentId, maka melakukan fetching
    } else if (!_.isEmpty(this.props.parentId)) {
      this.setState(
        {
          loadingOption: true,
          valueMultipleSelectOption: [],
          listExclude: [],
        },
        () =>
          this.getData(
            this.state.pageOption,
            this.state.limitOption,
            this.state.filterOption,
            this.props?.level,
            this.props?.parentId
          )
      );
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    this.checkingAllData(prevProps, prevState);
    this.checkingParentID(prevProps, prevState);
    if (
      prevProps.currentValue !== this.props.currentValue &&
      this.props.isEdit
    ) {
      this.getData(
        this.state?.pageOption,
        this.state?.limitOption,
        this.state?.filterOption,
        this.props?.level,
        this.props?.parentId
      );
    }
  };

  checkingAllData = (prevProps, prevState) => {
    if (this.state.selectAllOption !== prevState.selectAllOption) {
      if (this.state.selectAllOption) {
        const { t } = this.props;
        this.setState({
          selectAllOption: true,
          storeValue: `${this.state.countData.count_data} ${t("COMMON:OF")} ${this.state.countData.count_data}`,
        });
      }
    }
  };

  checkingParentID = (prevProps, prevState) => {
    if (
      this.props.parentId !== prevProps.parentId &&
      !this.state.changingLevel !== prevState.changingLevel
    ) {
      this.setState(
        {
          valueMultipleSelectOption:
            this.props.currentValue && !this.props.value.isExclude
              ? this.props.currentValue
              : [],
          selectAllOption: false,
          changingParent: !this.state.changingParent,
          changingLevel: true,
          loadingOption: true,
          listOption: [],
          listExclude:
            this.props?.value?.isExclude && this.state.listExclude.length === 0
              ? _.map(this.props?.value?.data, (el) => el.value)
              : this.state.listExclude,
        },
        () => {
          // this.props.getValue({
          //   flagCheckAll: this.state.selectAllOption,
          //   isExclude: this.state.exclude,
          //   data: [],
          // });
          this.getData(
            this.state.pageOption,
            this.state.limitOption,
            this.state.filterOption,
            this.props.level,
            this.props.parentId
          );
          this.getOptionAfterFetch();
        }
      );
    }
  };

  // componentDidMount() {

  // }

  getData = async (page, limit, search, level, parentId) => {
    
  console.log("dataaaa", this.state.list);
    let option = [];
    // Ketika melakukan filter
    if (page === 1 && this.state.isFilter) {
      option = [];
    } else if (page === 1) {
      option.push({
        id: 0,
        value: "All",
        checked: false,
      });
    } else {
      option = [...this.state.storeOption];
    }

    const currentOptionMapping = [...this.state.listOption];
    const { token, refresh_token, dispatch, t } = this.props;
    let filter = search && `name like ${search}, code like ${search}`;

    // Penamaan untuk params parent_list_id bisa berbeda beda dimasing masing api, tanya ke backend
    let parent_list_id;

    //isEmpty ini untuk mengecek apabila terdapat parentId dalam bentuk array maupun object
    if (!_.isEmpty(parentId)) {
      parent_list_id = _.map(parentId.data, (el) => {
        return el.id;
      });
      parent_list_id = _.join(parent_list_id, ",");
    }
    // Memberikan parameter not check limit agar menghiraukan limit yang sudah diberikan
    let params = {
      page: page,
      limit: limit,
      filter: filter,
      parent_list_id,
    };

      // const response = await SalesmanInfoService.msslist(
      //   token,
      //   refresh_token,
      //   params,
      //   dispatch
      // );

      // if (response.ok && response) {

      // const list = [
      //   {
      //     code: "Sunday",
      //     id: 1,
      //     name: "Sunday",
      //   },
      //   {
      //     code: "Monday",
      //     id: 2,
      //     name: "Monday",
      //   },
      //   {
      //     code: "Tuesday",
      //     id: 3,
      //     name: "Tuesday",
      //   },
      //   {
      //     code: "Wednesday",
      //     id: 4,
      //     name: "Wednesday",
      //   },{
      //     code: "Thursday",
      //     id: 5,
      //     name: "Thursday",
      //   },{
      //     code: "Friday",
      //     id: 6,
      //     name: "Friday",
      //   },{
      //     code: "Saturday",
      //     id: 7,
      //     name: "Saturday",
      //   },
      // ];
      if (this.state.list && this.state.list.length !== undefined) {
        for (let i = 0; i < this.state.list.length; i++) {
          const element = this.state.list[i];
          let data = {
            id: element.code,
            value: `${element.name}`,
            checked: this.getChecked({
              id: element.id,
              value: `${element.name}`,
              checked: true,
              disabled: false,
            }),
          };
          option.push(data);
        }
        this.setState(
          {
            countData: {
              count_data: this.state.list.length,
            },
            listOption: OptionMultiple(currentOptionMapping, option, "value"),
            loadingOption: false,
            initOption: !this.state.isFilter && option,
            storeOption: option,
            selectAllOption:
              this.props.isSelectAll && this.props.value?.flagCheckAll
                ? this.props.isSelectAll
                : this.state.selectAllOption,
            valueMultipleSelectOption:
              this.props.currentValue &&
              !this.state.changingLevel &&
              !this.props?.value?.isExclude
                ? this.props.currentValue
                : [...this.state.valueMultipleSelectOption],
            exclude: this.props.value?.isExclude
              ? this.props.value?.isExclude
              : this.state.exclude,
            listExclude:
              this.props?.value?.isExclude &&
              this.state.listExclude.length === 0
                ? _.map(this.props.value.data, (el) => el.value)
                : this.state.listExclude,
            storeValue:
              page === 1 && !this.state.isFilter
                ? `${this.state.initiate?.count_data} ${t("COMMON:OF")} ${this.state.initiate?.count_data}` !== this.state.storeValue &&
                  this.state.listExclude.length === 0 &&
                  this.state.selectAllOption &&
                  this.props.value?.flagCheckAll
                  ? `${this.state.initiate?.count_data} ${t("COMMON:OF")} ${this.state.initiate?.count_data}`
                  : !this.props.flagCheckAll
                  ? `0 ${t("COMMON:OF")} ${this.state.initiate?.count_data}`
                  : this.state.storeValue
                : this.state.exclude
                ? `${
                    this.state.countData.count_data -
                    this.state.listExclude.length
                  } ${t("COMMON:OF")} ${this.state.countData.count_data}`
                : this.state.storeValue,
          },
          () => {
            this.setState(
              {
                storeValue:
                  this.state.valueMultipleSelectOption?.includes("All") &&
                  !this.state.exclude &&
                  this.state.listExclude.length === 0
                    ? `${this.state.countData.count_data} ${t("COMMON:OF")} ${this.state.countData.count_data}`
                    : this.state.valueMultipleSelectOption.length > 0 &&
                      !this.state.exclude
                    ? `${this.state.valueMultipleSelectOption.length} ${t("COMMON:OF")} ${this.state.countData.count_data}`
                    : this.state.selectAllOption
                    ? `${this.state.countData.count_data} ${t("COMMON:OF")} ${this.state.countData.count_data}`
                    : this.state.listExclude.length !== 0 && this.state.exclude
                    ? `${
                        this.state.countData.count_data -
                        this.state.listExclude.length
                      } ${t("COMMON:OF")} ${this.state.countData.count_data}`
                    : this.state.storeValue,
              },
              () => {
                this.getOptionAfterFetch();
              }
            );
          }
        );
      } else {
        this.setState({
          storeValue: this.state.storeValue,
          loadingOption: false,
          listOption: [],
        });
      }
      // }
    
  };

  getOptionAfterFetch = () => {
    let value = [...this.state.storeOption];
    this.setState({
      listOption: _.map(value, (el, i) => {
        return (
          <>
            <Option key={el.id} value={el.value}>
              <div
                style={{
                  display: "flex",
                  cursor: "pointer",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  <span style={{ whiteSpace: "normal" }}>{el.value}</span>
                </div>
                <div
                  style={{
                    textAlign: "left",
                    marginRight: "15px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span style={{ width: "20%", marginLeft: "20%" }}>
                    <input
                      type={"checkbox"}
                      style={{ cursor: "pointer", color:"red" }}
                      checked={this.getChecked(el)}
                      onChange={(e) => this.onChange(e, el, "onChangeMss")}
                    />
                    {/* <img src={Checkbox} alt="check"
                      onChange={(e) => this.onChange(e, el, "onChangeMss")}/> */}
                  </span>
                </div>
              </div>
            </Option>
          </>
        );
      }),
    });
  };

  onChange = (e, i, from) => {
    const { t } = this.props;
    // setBanyakData
    if (_.isArray(e)) {
      this.setState({
        storeValue: e[0],
      });
    }
    if (from === "onChangeMss" && _.isArray(e)) {
      let tempOption = [...this.state.storeOption];
      let storeValues = this.state.storeValue;
      let find = _.find(tempOption, (el) => el.value === e[1]);
      // ALL OF ALL Data
      if (
        _.isEqual(
          e[0],
          `${this.state.countData.count_data} ${t("COMMON:OF")} ${this.state.countData.count_data}`
        )
      ) {
        if (_.isEqual(e[1], "All")) {
          storeValues = `0 ${t("COMMON:OF")} ${this.state.countData.count_data}`;
          if (tempOption[0]["value"] === "All") {
            tempOption[0]["checked"] = false;
            _.pull(this.state.valueMultipleSelectOption, "All");
          }
          this.setState(
            {
              exclude: false,
              listExclude: [],
              valueToParent: [],
              selectAllOption: false,
              valueMultipleSelectOption: [],
            },
            () => {
              this.setValueToParent();
              this.getOptionAfterFetch();
            }
          );
        } else {
          if (tempOption[0]["value"] === "All") {
            tempOption[0]["checked"] = false;
            _.pull(this.state.valueMultipleSelectOption, "All");
          }
          _.pull(this.state.valueMultipleSelectOption, e[1]);
          this.state.listExclude.push(e[1]);
          this.state.valueToParent.push(find);
          storeValues = `${
            this.state.countData.count_data - this.state.listExclude.length
          } ${t("COMMON:OF")} ${this.state.countData.count_data}`;
          this.setState(
            {
              exclude: true,
              selectAllOption: false,
            },
            () => {
              // this.setState({
              //   storeValue: `${this.state.countData.count_data - this.state.listExclude.length} of ${this.state.countData.count_data}`
              // },()=>this.getOptionAfterFetch())
            }
          );
        }
      }
      // 0 of All data dan "All"
      else if (
        !_.isEqual(
          e[0],
          `${this.state.countData.count_data} ${t("COMMON:OF")} ${this.state.countData.count_data}`
        ) &&
        _.isEqual(e[1], "All")
      ) {
        if (tempOption[0]["value"] === "All") {
          tempOption[0]["checked"] = true;
          this.state.valueMultipleSelectOption.push("All");
        }
        storeValues = `${this.state.countData.count_data} ${t("COMMON:OF")} ${this.state.countData.count_data}`;
        this.setState(
          {
            valueToParent: [],
            exclude: false,
            listExclude: [],
            valueMultipleSelectOption: [],
            selectAllOption: true,
          }
          // () => this.getOptionAfterFetch()
        );
      }
      // 0 of All, dan bukan "All"
      else {
        let index = _.findIndex(tempOption, (el) => el.value === e[1]);
        let indexValue = _.findIndex(
          this.state.valueMultipleSelectOption,
          (el) => el === e[1]
        );
        let indexExclude = _.findIndex(
          this.state.listExclude,
          (el) => el === e[1]
        );
        if (indexValue === -1) {
          if (indexExclude === -1 && this.state.exclude) {
            if (tempOption[0]["value"] === "All") {
              tempOption[0]["checked"] = false;
              _.pull(this.state.valueMultipleSelectOption, "All");
            }
            tempOption[index]["checked"] = false;
            this.state.valueToParent.push(find);
            this.state.listExclude.push(e[1]);
          } else if (this.state.isFilter) {
            tempOption[index]["checked"] = true;
            this.state.valueToParent.push(find);
            this.state.valueMultipleSelectOption.push(e[1]);
            _.pull(this.state.listExclude, e[1]);
          } else {
            tempOption[index]["checked"] = true;
            this.state.valueToParent.push(find);
            this.state.valueMultipleSelectOption.push(e[1]);
            _.pull(this.state.listExclude, e[1]);
          }
        } else {
          if (this.state.isFilter) {
            if (tempOption[index]["checked"]) {
              tempOption[index]["checked"] = false;
              this.state.valueToParent.push(find);
              this.state.listExclude.push(e[1]);
              _.pull(this.state.valueMultipleSelectOption, e[1]);
            } else {
              tempOption[index]["checked"] = true;
              this.state.valueToParent.push(find);
              this.state.valueMultipleSelectOption.push(e[1]);
              _.pull(this.state.listExclude, e[1]);
            }
          } else {
            _.pull(this.state.valueMultipleSelectOption, e[1]);
            this.state.valueToParent.push(find);
            this.state.listExclude.push(e[1]);
          }
        }
        storeValues = !this.state.exclude
          ? `${this.state.valueMultipleSelectOption.length} ${t("COMMON:OF")} ${this.state.countData.count_data}`
          : `${
              this.state.countData.count_data - this.state.listExclude.length
            } ${t("COMMON:OF")} ${this.state.countData.count_data}`;
      }
      this.setState(
        {
          storeOption: tempOption,
        },
        () => {
          let valueResult = [...this.state.storeOption];
          if (
            _.isEqual(storeValues, `0 ${t("COMMON:OF")} ${this.state.countData.count_data}`)
          ) {
            valueResult = _.map(this.state.storeOption, (el) => {
              return {
                ...el,
                checked: false,
              };
            });
          } else if (
            _.isEqual(
              storeValues,
              `${this.state.countData.count_data} ${t("COMMON:OF")} ${this.state.countData.count_data}`
            )
          ) {
            valueResult = _.map(this.state.storeOption, (el) => ({
              ...el,
              checked: true,
            }));
          }
          this.setState(
            {
              storeValue: storeValues,
              storeOption: [...new Set(valueResult)],
              selectAllOption: _.isEqual(
                storeValues,
                `${this.state.countData.count_data} ${t("COMMON:OF")} ${this.state.countData.count_data}`
              )
                ? true
                : false,
            },
            () => {
              this.setValueToParent();
              this.getOptionAfterFetch();
            }
          );
        }
      );
    }
  };

  setValueToParent = () => {
    let { valueMultipleSelectOption, storeOption, valueToParent, listExclude } =
      this.state;
    let dataResult = {
      flagCheckAll: this.state.selectAllOption,
      isExclude: this.state.exclude,
    };
    if (this.state.exclude) {
      let tempData = _.filter(valueToParent, (el) =>
        listExclude.includes(el.value)
      );
      tempData = _.map(tempData, (el) => ({
        id: el.id,
        value: el.value,
      }));
      tempData = _.uniqBy(tempData, "id");
      if (valueToParent?.length === this.state.countData?.count_data) {
        tempData = [];
      }
      dataResult = {
        ...dataResult,
        data: this.state.selectAllOption ? [{ id: 0, value: "All" }] : tempData,
        isExclude: this.state.selectAllOption ? false : true,
      };
    } else {
      let tempData = _.filter(valueToParent, (el) =>
        valueMultipleSelectOption.includes(el.value)
      );
      tempData = _.map(tempData, (el) => ({
        id: el.id,
        value: el.value,
      }));
      tempData = _.uniqBy(tempData, "id");
      dataResult = {
        ...dataResult,
        data: this.state.selectAllOption ? [{ id: 0, value: "All" }] : tempData,
      };
    }
    this.props.getValue(dataResult);
  };

  getChecked = (value) => {
    const { t } = this.props;
    let isFoundExclude = _.includes(this.state.listExclude, value.value);
    let data = _.find(this.state.storeOption, (el) => el.value === value.value);
    if (
      this.state.selectAllOption ||
      this.state.storeValue ===
        `${this.state.countData.count_data} ${t("COMMON:OF")} ${this.state.countData.count_data}`
    ) {
      return true;
    } else if (isFoundExclude) {
      return false;
    } else if (this.state.valueMultipleSelectOption.includes(value.value)) {
      if (value.value === "All") {
        return this.state.selectAllOption;
      } else {
        return true;
      }
    } else if (data?.checked !== undefined && !this.state.isFilter) {
      if (!this.state.selectAllOption && this.state.exclude) {
        if (value?.value === "All") {
          return false
        }
        return true
      } else if (!this.state.exclude) {
        return false;
      } else {
        return data?.checked;
      }
    } else if (
      !this.state.exclude &&
      this.state.valueMultipleSelectOption.includes(value.value)
    ) {
      return true;
    } else if (this.state.exclude) {
      return value?.checked;
    } else {
      return false;
    }
  };

  _onScroll = (event) => {
    let target = event.target;
    if (
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 ||
        target.scrollHeight - Math.ceil(target.scrollTop) ===
          target.clientHeight) &&
      !this.state.lastPageOption &&
      !this.state.loadingOption
    ) {
      this.setState(
        {
          loadingOption: true,
          pageOption: this.state.pageOption + 1,
        },
        () => {
          target.scrollTo(0, target.scrollHeight);
          setTimeout(
            () =>
              this.getData(
                this.state.pageOption,
                this.state.limitOption,
                this.state.filterOption
              ),
            256
          );
        }
      );
    }
  };

  // Set Disable Mss apabila level bukan 1 dan belum ada parent id dari level sebelumnya
  setDisabledMss = () => {
    if (this.props.level === 1) {
      return false;
    } else if (this.props.currentValue && !this.state.changingLevel) {
      return false;
    } else if (
      this.props.level !== 1 &&
      _.isEmpty(this.props?.parentId?.data) &&
      this.props?.parentId?.data !== undefined &&
      !this.props.parentId?.flagCheckAll
    ) {
      return true;
    } else {
      return false;
    }
  };

  handlerSearch = (event) => {
    const { value } = event.target;
    clearTimeout(this.inputTimer);
    if (value.length >= 6) {
      let searchData = [];
      _.forEach(this.state.storeOption, (el) => {
        if (el.value.toLowerCase().includes(value.toLowerCase())) {
          searchData.push(el);
        }
      });
      this.setState(
        {
          storeOption: searchData,
          isFilter: true,
        },
        () => this.getOptionAfterFetch()
      );
    } else if (!value) {
      this.setState(
        {
          isFilter: false,
          storeOption: this.state.initOption,
        },
        () => this.getOptionAfterFetch()
      );
    }
  };

  render() {
    return (
      <>
        <MultipleSelect
          showSearch={false}
          status={this.props.status}
          option={
            this.state.loadingOption
              ? [...this.state.listOption, LoadingOption()]
              : 
              this.state.listOption
          }
          dropdownRender={(menu) =>
            dropdownCustom(menu, (value) => this.handlerSearch(value))
          }
          // onPopupScroll={(evt) => this._onScroll(evt)}
          placeholder={`${this.props.t(
            "EXPORT_MACHINE_PRODUCTIVITY:CUSTOMER"
          )} `}
          // loading={this.state.loadingOption}
          disabled={this.setDisabledMss()}
          onChange={(e, i) => this.onChange(e, i, "onChangeMss")}
          value={[this.state.storeValue]}
          isError={
            this.props?.error
              ? this.props?.error &&
                _.isEmpty(this.props?.error[this.props?.errorNamespace])
                ? false
                : _.isNull(this.props?.error[this.props.errorNamespace])
                ? false
                : true
              : undefined
          }
        />
        {/* <ErrorMessage
          children={
            this.props.error && this.props.error[this.props.errorNamespace]
          }
        /> */}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // token: state.auth.token,
    // isAuthenticated: state.auth.isAuthenticated,
    // table_loading: state.page.table_loading,
    // auth_loading: state.page.auth_loading,
    // title_page: state.page.title_page,
    // schema: state.auth.schema,
    // prepare_component: state.page.prepare_component,
    // language: state.auth.language,
    // permission: state.permission.geo_tree,
    // refresh_token: state.auth.refresh_token,
  };
};

const mapDispatchToProps = (dispatch) => {
  return { dispatch };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(MSSTemperatureCategory));
